import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 9,
	viewBox: "0 0 9 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 9H5L5 5H9V4L5 4L5 0H4L4 4L0 4V5H4L4 9Z",
		fill: "#FAFAE5",
		fillOpacity: .4
	})
});
export { SvgUnion as ReactComponent };
